// eslint-disable-next-line no-restricted-imports
import { SdkStore } from "@sendbird/uikit-react/types/lib/types";
import { type FacilityExclusionApiResponse } from "@src/appV2/Facilities/api/useGetFacilitiesExclusions";
import { CustomMessageInput } from "@src/appV2/redesign/Chat/CustomMessageInput";

function EmptyMessage() {
  return <></>;
}

interface GetMessageInputDefinition {
  isLoading: boolean;
  sdk?: SdkStore["sdk"];
  actionBy?: FacilityExclusionApiResponse[number]["actionBy"];
  workerHasChartingNonComplianceAtWorkplace?: boolean;
  prefilledMessage?: string;
}
export function getMessageInputDefinition(definition: GetMessageInputDefinition) {
  const { isLoading, sdk, actionBy, workerHasChartingNonComplianceAtWorkplace, prefilledMessage } =
    definition;
  const disabledMessage = getChannelDisabledMessage(actionBy);

  // to make it compliant with sendbird's renderMessageInput
  if (isLoading || !sdk) {
    return EmptyMessage;
  } else if (!workerHasChartingNonComplianceAtWorkplace && disabledMessage) {
    // eslint-disable-next-line react/display-name
    return () => <div className="sendbird-disabled-chat">{disabledMessage}</div>;
  } else {
    // eslint-disable-next-line react/display-name
    return () => <CustomMessageInput prefilledMessage={prefilledMessage} />;
  }
}

function getChannelDisabledMessage(
  actionBy?: FacilityExclusionApiResponse[number]["actionBy"]
): string | undefined {
  if (actionBy === "AGENT") {
    return "You blocked this workplace. Chat disabled.";
  } else if (actionBy === "FACILITY") {
    return "You are blocked by this workplace. Chat disabled.";
  }
  return undefined;
}
